import { Typography } from "@mui/material";
import HelpDialogLayout, {
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface BodyConditionDialogProps extends HelpDialogLayoutProps {}
export default function BodyConditionDialog(props: BodyConditionDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">
            体調不良時の睡眠とその対処法
          </Typography>
          <Typography variant="body2">
            風邪などで体調を崩した場合、通常より長く寝たり、昼間に睡眠をとったりすることがあります。このような場合は規則正しい睡眠にはこだわらず、まずは体調の回復を優先しましょう。一方、かゆみや痛みなどは睡眠が阻害され、不眠をもたらすことがありますので、疾患によるかゆみや痛みが睡眠を妨害している場合はかかりつけ医に相談しましょう。
          </Typography>
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">体の痛みと睡眠の関係</Typography>
          <Typography variant="body2">
            慢性的に体の痛みが続く人の中には、寝付くまでに時間がかかる、夜中に何度も目が覚める、睡眠休養感を得られていない、など睡眠に影響を及ぼしている方もいます。慢性的な痛みと睡眠の関係性には、痛みが睡眠を悪化させるだけではなく、睡眠状態が悪くなると痛みにも悪影響を及ぼすという逆方向の関係性もあることがわかってきています。
          </Typography>
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">体のかゆみと睡眠の関係</Typography>
          <Typography variant="body2">
            人が眠りにつく時、深部体温が下がる一方で、手足などの末端はぽかぽかと温かくなります。この際に、手足などの末梢血管が拡張しますが、かゆみを感じている人の場合、この血管の拡張によってかゆみがひどくなり、寝付きづらくなることがあります。
          </Typography>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
